import request from '@/utils/request'

  //通过字典id查询数据
  export function getPmiDic(params) {
    return request({
      url: '/api/PmiDictionary/GetByTypeId',
      method: 'get',
      params
    })
  }

 //获取证书全部数据
  export function getCerInfoLoad(params) {
    return request({
      url: '/api/CerInfo/Load',
      method: 'get',
      params
    })
  }

// 获取警钟证书排行
  // export function getCerInfoJzTongJi(params) {
  //   return request({
  //     url: '/api/CerInfo/JzTongJi',
  //     method: 'get',
  //     params
  //   })
  // }

  export function SearchCerDataList(params) {
    return request({
      url:'/api/CerInfo/SearchCerDataList',
      method: 'get',
      params
    })
  }

  //证书展示接口
  export function GetCerDataDetail(params) {
    return request({
      url:'/api/CerInfo/GetCerDataDetail',
      method: 'get',
      params
    })
  }
   //下载
   export function DownCerPDF(params) {
    return request({
      url:'/resource/CerInfo/DownCerPDF',
      method: 'get',
      params
    })
  }
// 获取警钟证书排行
  export function CerInfoJzTongJiTop(params) {
    return request({
        url: '/api/CerInfo/JzTongJiTop',
        method: 'get',
        params
    })
}

// 最新活动证书
export function CerInfoNewCerInfoTop(params) {
  return request({
      url: '/api/CerInfo/NewCerInfoTop',
      method: 'get',
      params
  })
}
export function getLoadQT(params) {
  return request({
      url: '/api/CerInfo/LoadQT',
      method: 'get',
      params
  })
}


